export enum DialogSize {
  SIZE_SM = 'dialog-sm',
  SIZE_MD = 'dialog-md',
  SIZE_LG = 'dialog-lg',
  SIZE_FULL = 'dialog-full'
}
